import React, {useState, useContext} from 'react'
import {useStripe, useElements} from '@stripe/react-stripe-js';
import { CardElement } from '@stripe/react-stripe-js';
import { Button, Label } from 'semantic-ui-react'
import { NotificationManager } from 'react-notifications';
import { Text, Translate, LanguageContext } from '../../helpers/language';
import { backendService } from '../../services/backendService'

const CardForm = (props) => {
  const languageContext = useContext(LanguageContext);
  const stripe = useStripe();
  const elements = useElements();

  const [errorMessage, setErrorMessage] = useState('');
  const [error, setError] = useState(false);
  const [hasCard, setHasCard] = useState(false);
  const [loading, setLoading] = useState(false);
  const [cardHolderName, setCardHolderName] = useState('');

  const {  
           customerId,
           show_header,
           header_text,
           button_text,
           button_disabled,
           handleResult,
    } = props;
 
  const handleChange = ({ err, complete }) => {
    if (err) {
      //messages from stripe are translated already
      setErrorMessage(err.message);
      setError(true);
      setHasCard(false);      
    } else {
      setErrorMessage('');
      setError(false);
      setHasCard(complete);      
    }
  };

  const confirmCardSetup = (clientSecret) => {
    const cardElement = elements.getElement(CardElement);    
    const payment_method = { card: cardElement };
    if (cardHolderName)
      payment_method.billing_details = { name: cardHolderName }
    stripe.confirmCardSetup( clientSecret, {
        payment_method: payment_method        
      }).then(confirmationResponse => {        
        if (confirmationResponse.setupIntent && confirmationResponse.setupIntent.status === 'succeeded') {          
          handleResult(confirmationResponse.setupIntent.payment_method).then( (result) => {
            if (result) 
              NotificationManager.success(Translate(languageContext, 'subscription_payment_method_updated'));
          });          
        } else {          
          NotificationManager.error(Translate(languageContext, 'subscription_payment_method_update_fail')); 
          setLoading(false);
        }
      }, e=> {
        NotificationManager.error(Translate(languageContext, 'subscription_payment_method_update_fail')); 
        setLoading(false);
      });
  }

  const handleSubmit = async (evt) => {
    setLoading(true);
    evt.preventDefault();
    try {
        if (!stripe || !elements || !customerId) {       
          NotificationManager.error(Translate(languageContext, 'subscription_payment_method_update_fail')); 
        } 

        backendService.post('/api/stripe/setup_intents', {
          customer: customerId,
          usage: 'off_session'
        }).then( clientSecretResponse => {
          if (clientSecretResponse && clientSecretResponse.data && clientSecretResponse.data.client_secret)
            confirmCardSetup(clientSecretResponse.data.client_secret);            
          else {                
            NotificationManager.error(Translate(languageContext, 'subscription_payment_method_update_fail')); 
            setLoading(false);
          }          
        }, e => {              
          NotificationManager.error(Translate(languageContext, 'subscription_payment_method_update_fail')); 
          setLoading(false);
        });            

    } catch(exc) {
        console.error(exc);
        NotificationManager.error(Translate(languageContext, 'subscription_payment_method_update_fail'))
        setLoading(false);
    }
    
  };

  const createOptions = () => {
    return {      
      style: {
        base: {
          fontSize: '16px',
          color: '#424770',
          fontFamily: 'Open Sans, sans-serif',
          letterSpacing: '0.025em',
          '::placeholder': {
            color: '#aab7c4',
          },
        },
        invalid: {
          color: '#c23d4b',
          iconColor: '#ffc7ee',
        },
      }
    }
  }

  return (
    <div>        
        {show_header && <h4><Text tid={header_text ? header_text : 'subscription_payment_method' } /></h4>}
        <CardElement
          onChange = {handleChange}
          options = {createOptions()}
        />
        { error  &&
          <Label basic color='red' pointing>
              {errorMessage}
          </Label>
        }          
        <Button onClick={handleSubmit} className='confirmPaymentButton lisia-blue' disabled={!hasCard || loading || button_disabled} style={{width: '100%'}}><Text tid={button_text ? button_text : 'subscription_update_payment_method' } /></Button>        
    </div>
  );

}

export default CardForm